import { useNavigate } from "react-router-dom";
import Badge from "../../ui/Badge/Badge";
import Button from "../../ui/Button/Button";
import Page from "../Page";
import styles from "./NotFound.module.scss";
import urls from "../../routes";
import Background from "./Background.svg?react";

function NotFound() {
  const navigate = useNavigate();

  return (
    <Page
      title="Not found"
      documentTitle="Not found"
      showHeader={false}
      fullHeight
    >
      <div className={styles.container}>
        <div className={styles.badgeContainer}>
          <Background className={styles.background} />
          <Badge variant="badge" color="primary" className={styles.badge}>
            404
          </Badge>
        </div>

        <h1 className={styles.title}>We can&apos;t find this page</h1>
        <p className={styles.subtitle}>
          The page you are looking for doesn&apos;t exist or has been moved.
        </p>
        <Button
          variant="primary"
          size="large"
          onClick={() => navigate(urls.home)}
        >
          Go home
        </Button>
      </div>
    </Page>
  );
}

export default NotFound;
